import styled from "styled-components"

const StyledTraySwatch = styled.div`
  width: 100%;
  height: 100%;
  background-image: ${p => `url("${p.tray}")`};
  background-position: 50% 50%;
  background-repeat: no-repeat;
`

export default StyledTraySwatch
